import { render, staticRenderFns } from "./MasterCar.vue?vue&type=template&id=8b20a140&scoped=true&lang=pug&"
import script from "./scripts/MasterCar.js?vue&type=script&lang=js&"
export * from "./scripts/MasterCar.js?vue&type=script&lang=js&"
import style0 from "./MasterCar.vue?vue&type=style&index=0&id=8b20a140&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b20a140",
  null
  
)

export default component.exports